module.exports = __webpack_public_path__ + "static/img/ent-62.65d972f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-62.jpg
// module id = 84la
// module chunks = 52